import { createContext, useContext, useState } from 'react'

const WarehouseContext = createContext()

export const WarehouseProvider = ({ children }) => {
  const [warehouseRole, setWarehouseRole] = useState(null)

  const updateWarehouseRole = (warehouseId) => {
    setWarehouseRole(warehouseId)
  }

  return (
    <WarehouseContext.Provider value={{ warehouseRole, updateWarehouseRole }}>
      {children}
    </WarehouseContext.Provider>
  )
}

export const useWarehouseRole = () => {
  const context = useContext(WarehouseContext)
  if (!context) {
    throw new Error('useWarehouseRole must be used within a WarehouseProvider')
  }
  return context
}
